import {Injectable} from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import {SessionService} from '../services/session.service';
import {AuthStatusByCodeUtil} from '../../model/util/auth-status-by-code-util';
import {AuthStatus} from '../../model/enum/auth-status.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {

  trackingId: string;

  constructor(private router: Router, private route: ActivatedRoute, private sessionService: SessionService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.trackingId = next.params['trackingId'];
    return this.checkAuthStatus();
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkAuthStatus();
  }

  private checkAuthStatus(): boolean {
    this.sessionService.getInitUser(this.trackingId).subscribe(response => {
      if (response == null) {
        this.router.navigate(['/result/error', this.trackingId]);
        return false;
      } else {
        let authStatus = AuthStatusByCodeUtil.getAuthStatusByCode(response.authStatus);
        if (authStatus != AuthStatus.WAITING_OTP_CHECK && authStatus != AuthStatus.WAITING_PIN_VALIDATION &&
          authStatus != AuthStatus.WAITING_OTP_VALIDATION && authStatus != AuthStatus.WAITING_CARD_VALIDATION &&
          authStatus != AuthStatus.WAITING_REGISTRATION && authStatus != AuthStatus.WAITING_CREATE_PIN &&
          authStatus != AuthStatus.AUTHENTICATED && authStatus != AuthStatus.WAITING_REFRESH_PIN) {
          this.router.navigate(['/result/error', this.trackingId]);
          return false;
        } else {
          this.router.navigate(['/route', this.trackingId]);
          return true;
        }
      }
    }, error => {
      this.router.navigate(['/result/error', this.trackingId]);
      return false;
    });
    return true;
  }
}
